import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

const isValidPhone = (phone: string) => {
    try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
    } catch (err) {
        return false;
    }
};

const formatPhone = (phone: string) => {
    try {
        return phoneUtil.format(phoneUtil.parseAndKeepRawInput(phone), PhoneNumberFormat.E164);
    } catch {
        return phone;
    }
};

const displayPhone = (phone: string) => {
    try {
        const parsedNumber = phoneUtil.parseAndKeepRawInput(phone);
        const code = parsedNumber.getCountryCode();
        const nationalNumber = phoneUtil.format(parsedNumber, PhoneNumberFormat.NATIONAL);

        return `+${code} ${nationalNumber}`;
    } catch {
        return phone;
    }
};

const displayPhoneDottedNoCountryCode = (phone: string) => {
    try {
        const parsedNumber = phoneUtil.parseAndKeepRawInput(phone);
        const nationalNumber = phoneUtil.format(parsedNumber, PhoneNumberFormat.NATIONAL);

        return nationalNumber
            .replace(/[^0-9]/g, '.') // replace all with dots except numbers
            .replace(/\.{2,}/g, '.') // remove dots dupes
            .replace(/^\.*/, ''); // remove first dot
    } catch {
        return phone;
    }
};

export { isValidPhone, formatPhone, displayPhone, displayPhoneDottedNoCountryCode };
